import createCookie from "../utils/createCookie";
import getParameterByName from "../utils/getParameterByName";
import { indications } from "../utils/indications";

function init() {
    if (getParameterByName("MOC")) createCookie("Dupixent-MOC", getParameterByName("MOC"));
    var indication = document.body.dataset.indication;
    if (indications.includes(indication)) {
        createCookie("indication", indication);
    } else {
        var indicationClass = "indication-" + indication;
        var franchiseClass = "indication-franchise";
        document.body.dataset.indication = "franchise";
        document.body.classList.remove(indicationClass);
        document.body.classList.add(franchiseClass);
        createCookie("indication", "franchise");
    }
}

export default { init };
